// Admin Templates page search predicate — extracted to its own file (rather
// than inline in TemplatesPage.jsx) purely so it's unit-testable: this
// project's plain `node --test` runner has no JSX transform, so a .jsx file
// can never be imported from a node:test file even for a JSX-free helper
// function defined inside it. Mirrors conversationSearch.js/flowSearch.js's
// style otherwise.

// Strips HTML tags before matching so markup doesn't cause search noise —
// same reasoning as htmlTemplateToPlainText()/htmlToPlainText() elsewhere in
// this codebase, but simpler here since only plain substring matching (not
// display) is needed.
export function stripHtml(html) {
  return (html ?? '').replace(/<[^>]+>/g, '')
}

// Template search predicate (title or content, case-insensitive substring).
export function matchesTemplateSearch(template, query) {
  const q = query.trim().toLowerCase()
  if (!q) return true
  return Boolean(
    template.title?.toLowerCase().includes(q) ||
    stripHtml(template.content).toLowerCase().includes(q)
  )
}
